module.exports = {"370923001":"东平街道","370923002":"州城街道","370923003":"彭集街道","370923101":"沙河站镇","370923106":"老湖镇","370923107":"银山镇","370923108":"斑鸠店镇","370923109":"接山镇","370923110":"大羊镇","370923111":"梯门镇","370923112":"新湖镇","370923113":"戴庙镇","370923206":"商老庄乡","370923208":"旧县乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370923.json
// module id = 1440
// module chunks = 0